/**
 * Группы инструментов на главной (#169, пункты 4 и 6).
 *
 * Карточки шли одним списком в порядке появления, «от старых к новым».
 * Это порядок нашей разработки, а не порядок полезности: посетитель
 * видел сначала то, что было сделано раньше. Здесь инструменты
 * сгруппированы по задаче, с которой человек приходит.
 *
 * Заголовки групп заодно дают странице текст. Его на главной было 268
 * слов при тридцати с лишним ссылках, и для поисковика она выглядела
 * оглавлением, а не страницей.
 *
 * Порядок в `DH_TOOLS` намеренно оставлен прежним: там он повторяет
 * историю и используется шапкой и подвалом, где привычное расположение
 * ссылок важнее группировки. Показ и перечисление — разные задачи.
 */

import { DH_TOOLS } from '@/lib/dh-tools';

/** Группа карточек: ключ перевода заголовка и состав. */
export interface ToolGroup {
  /** Основа ключей `group_<id>` и `group_<id>_desc` в `dh_home`. */
  id: string;
  /** Ключи `card` инструментов этой группы, в порядке показа. */
  tools: string[];
}

/**
 * Состав групп.
 *
 * Каждый инструмент входит ровно в одну группу: инструмент, попавший в
 * две, показался бы дважды, а забытый исчез бы с главной вовсе. За этим
 * следит тест.
 *
 * Внутри группы порядок не исторический, а по ожидаемому спросу: первым
 * идёт то, за чем приходят чаще.
 */
export const TOOL_GROUPS: ToolGroup[] = [
  // Работа с документами: то, что человек принёс с собой и хочет
  // изменить.
  { id: 'documents', tools: ['pdf', 'markdown', 'video'] },
  // Разработчику: форматы, коды, сеть.
  // Наборы данных — первыми: за ними приходят чаще, чем за любым
  // инструментом группы (подсказки Google, ТЗ Seo-marketing 12.10.2026).
  { id: 'developer', tools: ['datasets', 'json', 'qr', 'proxy', 'proxy_check'] },
  // Сеть и домены: свой адрес, DNS, WHOIS, SSL (ТЗ Seo-marketing,
  // 13.10.2026). Прокси остаются у разработчика — там их ищут давно.
  { id: 'network', tools: ['myip', 'dns', 'whois', 'ssl'] },
  // Личное: то, что помогает самому человеку, а не его файлам.
  { id: 'personal', tools: ['flowtime', 'breathing', 'mic', 'xnote', 'transfer', 'saga'] },
];

/** Инструмент по ключу карточки. */
export function toolByCard(card: string) {
  return DH_TOOLS.find((t) => t.card === card);
}

/** Все ключи карточек, перечисленные в группах. */
export function groupedCards(): string[] {
  return TOOL_GROUPS.flatMap((g) => g.tools);
}
